import React from 'react';
import PropTypes from 'prop-types';
import Columns from './DataComponent__TableColumns';
import actions from './DataComponent.actions';

const DataComponentSettings = ({
    settings = false,
    tableBodyTitle = '',
    settingKey = '',
    data = []
}) => {
    const renderSettings = () => {
        if (!settings) return null;

        return (
            <React.Fragment>
                <div className={`settingsBar ${tableBodyTitle ? 'settingsBar--withTitle' : ''}`}>
                    <div>
                        <Columns
                            settingKey={settingKey}
                            data={data}
                            onApply={actions.saveServerStorage}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    };

    return renderSettings();
};

DataComponentSettings.propTypes = {
    settings: PropTypes.bool,
    tableBodyTitle: PropTypes.string,
    settingKey: PropTypes.string,
    data: PropTypes.array
};

DataComponentSettings.defaultProps = {
    settings: false,
    tableBodyTitle: '',
    settingKey: '',
    data: []
};

export default DataComponentSettings;
